<template>
  <b-card title="Expedientes en Estado">
    <feather-icon
        icon="SettingsIcon"
        size="15"
        class="spinner"
        v-if="isLoading"
    />
    <app-echart-bar
        :option-data="option"
        v-if="!isLoading"
        @click="handleClick"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';

import AppEchartBar from '@core/components/charts/echart/AppEchartBar';
import { getStates } from '@/febos/chile/dnt/mixins/EdFilesExpStates';
import { ioIndicadoresExpedientesSearch } from '@/febos/servicios/api/busqueda.api';

const states = getStates();
export default {
  name: 'BarFilesByStateAndDate',
  components: {
    BCard,
    AppEchartBar
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      option: {
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false }
          }
        ],
        grid: {
          left: '40px',
          right: '30px',
          bottom: '30px'
        },
        series: []
      }
    };
  },
  methods: {
    async loadIndicator(filter) {
      this.isLoading = true;
      const {
        data: {
          datos
        }
      } = await ioIndicadoresExpedientesSearch(
        {
          campos: 'estado',
          filtros: filter
        }
      );
      const data = Object.entries(states).map(
        ([key, state]) => {
          if (datos[state.id]) {
            return {
              value: datos[state.id], name: state.description, id: state.id, key
            };
          }
          return null;
        }
      ).filter((item) => item !== null);

      const option = {};
      option.xAxisData = data.map((item) => item.name);
      option.series = [
        {
          name: 'Cantidad',
          type: 'bar',
          data
        }
      ];
      this.option.xAxis[0].data = option.xAxisData;
      this.option.series = option.series;

      this.isLoading = false;
    },
    handleClick({ data }) {
      console.log('handleClick', data);
      this.$emit('selected-card', {
        id: `${this.id }-${ data.id}`,
        filters: `estado:${ data.id}`
      });
    }
  }

};
</script>
